import React from 'react';
import CSS from 'csstype';

type Props = {
  style?: CSS.Properties<string | number>;
  className?: string;
};

function Pharmacy({ style = {}, className = '' }: Props) {
  return (
    <svg
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#2F4050"
          d="M19.425 4c.487 0 .883.377.883.84v1.187h.832c.083 0 .154.058.166.137l.537 3.238c.016.1-.063.187-.166.187h-.356v.001l.005 9.751c0 .491-.403.89-.898.89H3.27c-.495 0-.899-.399-.899-.89L2.363 9.6l.002-.01h-.197c-.104 0-.183-.088-.166-.187l.536-3.238c.013-.079.083-.137.166-.137h.824V4.84c0-.463.397-.84.884-.84zm.896 5.59H3.361l.002.01.008 9.631h1.684v-6.924c0-.38.313-.69.696-.69h4.7c.383 0 .695.31.695.69v6.924h9.18l-.005-9.64v-.002zm-10.175 3.027h-4.09v6.614h4.09v-6.614zm5.203-.65c.831 0 1.37.5 1.37 1.272 0 .52-.209.892-.618 1.11.145.257.452.802.632 1.126.08-.147.178-.32.256-.453l.312-.529h1.201l-1.17 1.88 1.22 1.96h-1.199l-.364-.61c-.073-.125-.17-.299-.254-.448-.083.151-.183.325-.256.447l-.362.61H14.92l1.215-1.96-1.098-1.84h-.477v1.273h-1.008v-3.839zm-6.248 3.722c.276 0 .5.224.5.5s-.224.5-.5.5h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5zm0-2.036c.276 0 .5.224.5.5s-.224.5-.5.5h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5zm6.232-.698h-.774v.61h.774c.312 0 .355-.149.355-.31 0-.157-.043-.3-.355-.3zm5.102-5.928H3.41L3.15 8.59h17.544l-.259-1.562zM19.308 5H4.528v1.027h14.78V5z"
        />
        <path d="M0 0H24V24H0z" />
      </g>
    </svg>
  );
}

export default Pharmacy;
